import {each, isNil, omitBy} from 'lodash';

export class ObjectHelper {

    public static deepOmit(data: unknown): unknown {
        let ommitedData;
        if (Array.isArray(data)) {
            ommitedData = ObjectHelper.deepOmitArray(data);
        } else if (typeof (data) === 'object') {
            ommitedData = ObjectHelper.deepOmitObject(data);
        } else {
            ommitedData = data;
        }
        if (ObjectHelper.isEmpty(ommitedData)) {
            return undefined;
        }
        return ommitedData;
    }

    // TODO ERIC RESPONSE PROPOSAL. PLEASE DO DELETE THE FOLLOWING LINES
    public static findValuesByPropertyName<T>(obj: unknown, propertyName: string): Array<T> {
        let list = [];
        if (!obj) {
            return list;
        }
        if (obj instanceof Array) {
            for (const o of obj) {
                list = list.concat(ObjectHelper.findValuesByPropertyName(o, propertyName));
            }
            return list;
        }
        if (obj[propertyName]) {
            list.push(obj[propertyName]);
        }
        if (typeof obj === 'object') {
            const children = Object.keys(obj);
            if (children.length > 0) {
                for (const c of children) {
                    list = list.concat(ObjectHelper.findValuesByPropertyName(obj[c], propertyName));
                }
            }
        }
        return list;
    }

    private static deepOmitArray(array: Array<unknown>): unknown {
        array.forEach((item, index) => {
            array[index] = this.deepOmit(item);
        });
        return array.filter((value => !!value));
    }

    private static deepOmitObject(data: object): unknown {
        each(data, (value, key) => {
            if (typeof (value) === 'object') {
                data[key] = this.deepOmit(value);
            }
        });
        return omitBy(data, isNil);
    }

    private static isEmpty(value: unknown): boolean {
        return typeof (value) === 'object' && Object.keys(value).length === 0;
    }
}
